import {
  GENERICS_HTTP_STATUS_CODES_MAPPER,
  getGenericBlockerErrors,
  HttpStatusMapper,
} from '@repo/core'
import { accountListDataActions, productsByTypeDataActions } from '../../slices'

// *********************************************** //
// [ DOC ]:                                        //
// En este archivo, se deben agregar las acciones  //
// que no tengan un codigo de error devuelto del   //
// backend y se desee controlar la notificacion en //
// base a su httpCode                              //
// [action.getResponse.type]: {                    //
//  ...getGenericBlockerErrors(                     //
//    [400, 404, 422, 500, 501, 502, 503],         //
//   409: "409_CUSTOM_ERROR_CODE"                  //
//  )}                                             //
// *********************************************** //

export const httpStatusErrorCodesMapper: HttpStatusMapper = {
  [productsByTypeDataActions.getResponse.type]: {
    ...getGenericBlockerErrors([400, 404, 422, 500, 501, 502, 503, 504]),
  },
  [accountListDataActions.getResponse.type]: {
    ...getGenericBlockerErrors([400, 404, 422, 501, 502, 503, 504]),
  },
  GENERICS: GENERICS_HTTP_STATUS_CODES_MAPPER,
}
